<template>
  <div class="font-body">
    <slot />
  </div>
</template>
